import Dashboard from '@/components/Dashboard';
import PageRoomplan from '@/components/pages/PageRoomplan';
import MainNav from '@/components/lib/layout/nav/MainNav';
import TestNav from '@/components/lib/layout/nav/TestNav';
import FolioNav from '@/components/lib/layout/nav/FolioNav';
import EmptyNav from '@/components/lib/layout/nav/EmptyNav';
import AppHeader from '@/components/lib/layout/AppHeader';
import AppHeaderWhite from '@/components/lib/layout/AppHeaderWhite';
import PageRoomReservation from '@/components/pages/PageRoomReservation';
import PageMeldeblatt from '@/components/pages/PageMeldeblatt';
import PageReservationGroup from '@/components/pages/PageReservationGroup';
import PageGuestOffer from '@/components/pages/PageGuestOffer';
import PageGuestProfile from '@/components/pages/PageGuestProfile';
import PageCreateReservation from '@/components/pages/PageCreateReservation';
import PageDraftReservation from '@/components/pages/PageDraftReservation';
import PageFindGuestProfile from '@/components/pages/PageFindGuestProfile';
import PageFindReservation from '@/components/pages/PageFindReservation';
import PageLogin from '@/components/pages/PageLogin';
import PageFrontDesk from '@/components/pages/PageFrontDesk';
import PageCockpit from '@/components/pages/PageCockpit';
import PageNotifications from '@/components/pages/PageNotifications';
import PageFolios from '@/components/pages/PageFolios';
import PageFolio from '@/components/pages/PageFolio';
import PageFindGuestOffer from '@/components/pages/PageFindGuestOffer';
import PageFindHotelInquiry from '@/components/pages/PageFindHotelInquiry';
import PageHotelInquiry from '@/components/pages/PageHotelInquiry';
import PageEmail from '@/components/pages/PageEmail';
import PageSwitchHotel from '@/components/pages/admin/PageSwitchHotel';
import PageRoomType from '@/components/pages/admin/PageRoomType';
import RoomTypeNav from '@/components/lib/layout/nav/admin/RoomTypeNav';
import PageRoomTypes from '@/components/pages/admin/PageRoomTypes';
import PageRoom from '@/components/pages/admin/PageRoom';
import RoomNav from '@/components/lib/layout/nav/admin/RoomNav';
import PageRooms from '@/components/pages/admin/PageRooms';
import PageRatePlan from '@/components/pages/admin/PageRatePlan';
import RatePlanNav from '@/components/lib/layout/nav/admin/RatePlanNav';
import PageRatePlans from '@/components/pages/admin/PageRatePlans';
import PageInHouseServices from '@/components/pages/admin/PageInHouseServices';
import PageInHouseService from '@/components/pages/admin/PageInHouseService';
import InHouseServiceNav from '@/components/lib/layout/nav/admin/InHouseServiceNav';
import PageMealPlans from '@/components/pages/admin/PageMealPlans';
import PageMealPlan from '@/components/pages/admin/PageMealPlan';
import MealPlanNav from '@/components/lib/layout/nav/admin/MealPlanNav';
import PageTaxes from '@/components/pages/admin/PageTaxes';
import PageTax from '@/components/pages/admin/PageTax';
import TaxNav from '@/components/lib/layout/nav/admin/TaxNav';
import PageAgeCategory from '@/components/pages/admin/PageAgeCategory';
import AgeCategoryNav from '@/components/lib/layout/nav/admin/AgeCategoryNav';
import PageAgeCategories from '@/components/pages/admin/PageAgeCategories';
import PageSeasonCalendar from '@/components/pages/admin/PageSeasonCalendar';
import PageSeasonCalendars from '@/components/pages/admin/PageSeasonCalendars';
import SeasonCalendarNav from '@/components/lib/layout/nav/admin/SeasonCalendarNav';
import PageSeasons from '@/components/pages/admin/PageSeasons';
import SeasonNav from '@/components/lib/layout/nav/admin/SeasonNav';
import PageSeason from '@/components/pages/admin/PageSeason';
import PageHotel from '@/components/pages/admin/PageHotel';
import PageInvoiceSettings from '@/components/pages/admin/PageInvoiceSettings';
import PageHotelSettings from '@/components/pages/admin/PageHotelSettings';
import PageDocument from '@/components/pages/PageDocument';
import PageSeasonRateEditor from '@/components/pages/admin/PageSeasonRateEditor';
import PageSeasonRateEditorRatePlans from '@/components/pages/admin/PageSeasonRateEditorRatePlans';
import SeasonRateEditorNav from '@/components/lib/layout/nav/admin/SeasonRateEditorNav';
import PageListReports from '@/components/pages/PageListReports';
import PageTemplates from '@/components/pages/admin/PageTemplates';
import PageTemplate from '@/components/pages/admin/PageTemplate';
import TemplateNav from '@/components/lib/layout/nav/admin/TemplateNav';
import PageUsers from '@/components/pages/admin/PageUsers';
import PageUser from '@/components/pages/admin/PageUser';
import UserNav from '@/components/lib/layout/nav/admin/UserNav';
import PageInterfaces from '@/components/pages/admin/PageInterfaces';
import PageHotelSpider from '@/components/pages/admin/interfaces/PageHotelSpider';
import InterfaceNav from '@/components/lib/layout/nav/admin/InterfaceNav';
import PageMeldeclient from '@/components/pages/admin/interfaces/PageMeldeclient';
import PageATrustRegMobile from '@/components/pages/admin/interfaces/PageATrustRegMobile';
import PageRegistrierkasseAT from '@/components/pages/admin/PageRegistrierkasseAT';
import PageExchangeRates from '@/components/pages/admin/interfaces/PageExchangeRates';
import PageCashBook from '@/components/pages/PageCashBook';
import PageSupport from '@/components/pages/PageSupport';
import PageFiskaltrustDE from '@/components/pages/admin/interfaces/PageFiskaltrustDE';
import PageRegistrierkasseDE from '@/components/pages/admin/PageRegistrierkasseDE';
import PageKassenSichV from '@/components/pages/PageKassenSichV';
import PageMollie from '@/components/pages/admin/interfaces/PageMollie';
import PageStripe from '@/components/pages/admin/interfaces/PageStripe';
import PageOnlineBooking from '@/components/pages/admin/interfaces/PageOnlineBooking';
import PagePaymentRequest from '@/components/pages/reservation/PagePaymentRequest';
import PageCreateTenant from '@/components/pages/admin/PageCreateTenant';
import SpecialNav from '@/components/lib/layout/nav/SpecialNav';
import PageFanz from '@/components/pages/admin/interfaces/PageFanz';
import PageHotelmeisterInvoices from '@/components/pages/admin/PageHotelmeisterInvoices';
import PageKiosk from '@/components/pages/admin/interfaces/PageKiosk';
import PageLogs from '@/components/pages/admin/interfaces/PageLogs';
import PageGuestCategories from '@/components/pages/admin/PageGuestCategories';
import PageInteralpSalesbox from '@/components/pages/admin/interfaces/PageInteralpSalesbox';
import PageMessagingSequences from '@/components/pages/admin/PageMessagingSequences';
import PageChannelManagerSu from '@/components/pages/admin/interfaces/PageChannelManagerSu';
import PageGenericPos from '@/components/pages/admin/interfaces/PageGenericPos';
import PageInventory from '@/components/pages/admin/PageInventory';
import PageChannelManagerSuLogs from '@/components/pages/admin/interfaces/PageChannelManagerSuLogs';
import PageChannelManagerSuMapping from '@/components/pages/admin/interfaces/PageChannelManagerSuMapping';
import PageChannelManagerSuBookings from '@/components/pages/admin/interfaces/PageChannelManagerSuBookings';
import PageInventoryLogs from '@/components/pages/admin/PageInventoryLogs';
import PageDayRateEditor from '@/components/pages/admin/PageDayRateEditor';
import PageTaxSets from '@/components/pages/admin/PageTaxSets';
import TaxSetNav from '@/components/lib/layout/nav/admin/TaxSetNav';
import PageTaxSet from '@/components/pages/admin/PageTaxSet';
import PagePaymentRequestSettings from '@/components/pages/admin/interfaces/PagePaymentRequestSettings';
import PageChannelManagerCx from '@/components/pages/admin/interfaces/PageChannelManagerCx';
import PageChannelManagerCxMapping from '@/components/pages/admin/interfaces/PageChannelManagerCxMapping';
import PageChannelManagerCxIframe from '@/components/pages/admin/interfaces/PageChannelManagerCxIframe';
import PageLockingSettings from '@/components/pages/admin/interfaces/PageLockingSettings.vue';
import PageDayRateOverview from '@/components/pages/admin/PageDayRateOverview.vue';
import PagePolicies from '@/components/pages/admin/PagePolicies.vue';
import PolicyNav from '@/components/lib/layout/nav/admin/PolicyNav.vue';
import PagePolicy from '@/components/pages/admin/PagePolicy.vue';
import PageImport from '@/components/pages/admin/PageImport.vue';
import PageLockingSeamIframe from '@/components/pages/admin/interfaces/PageLockingSeamIframe.vue';
import PageICal from '@/components/pages/admin/interfaces/PageICal.vue';
import PageDiscountCodes from '@/components/pages/admin/PageDiscountCodes.vue';
import DiscountCodeNav from '@/components/lib/layout/nav/admin/DiscountCodeNav.vue';
import PageDiscountCode from '@/components/pages/admin/PageDiscountCode.vue';
import PageCharPmsLink from '../components/pages/admin/interfaces/PageCharPmsLink.vue';
import PageSmartpricing from '../components/pages/admin/interfaces/PageSmartpricing.vue';
import PageChannelManagerSuMappingV2 from '../components/pages/admin/interfaces/PageChannelManagerSuMappingV2.vue';
import PageReviewSelfCheckInCandidates from '../components/pages/PageReviewSelfCheckInCandidates.vue';


export default [
  {
    path: '/',
    redirect: {
      name: 'login',
    },
  },
  {
    path: '/:hotelId/playground',
    name: 'playground',
    components: {
      default: Dashboard,
      nav: MainNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
    },
  },
  {
    path: '/login',
    name: 'login',
    components: {
      default: PageLogin,
    },
  },
  {
    path: '/:hotelId/hotels',
    name: 'hotels',
    components: {
      default: PageSwitchHotel,
      nav: MainNav,
      header: AppHeader,
    },
    meta: {
      role: ['ROLE_SYSADMIN'],
    },
  },
  {
    path: '/:hotelId/',
    name: 'home',
    components: {
      default: PageFrontDesk,
      nav: MainNav,
      header: AppHeader,
    },
    meta: {
      role: ['ROLE_USER', 'ROLE_UNIT_OWNER'],
    },
  },
  {
    path: '/:hotelId/cockpit',
    name: 'cockpit',
    components: {
      default: PageCockpit,
      nav: MainNav,
      header: AppHeader,
    },
    meta: {
      role: ['ROLE_USER'],
    },
  },
  {
    path: '/:hotelId/support',
    name: 'support',
    components: {
      default: PageSupport,
      nav: MainNav,
      header: AppHeader,
    },
    meta: {
      role: ['ROLE_USER', 'ROLE_UNIT_OWNER'],
    },
  },
  {
    path: '/:hotelId/roomplan',
    name: 'roomplan',
    components: {
      default: PageRoomplan,
      nav: MainNav,
      header: AppHeader,
    },
    meta: {
      role: ['ROLE_USER', 'ROLE_UNIT_OWNER'],
      reload: true,
    },
  },
  {
    path: '/:hotelId/notifications',
    name: 'notifications',
    components: {
      default: PageNotifications,
      nav: MainNav,
      header: AppHeader,
    },
    meta: {
      role: ['ROLE_USER'],
      reload: true,
    },
  },
  {
    path: '/:hotelId/cashBook',
    name: 'cashBook',
    components: {
      default: PageCashBook,
      nav: MainNav,
      header: AppHeader,
    },
    meta: {
      role: ['ROLE_INVOICING', 'ROLE_ADMIN', 'ROLE_SYSADMIN'],
      reload: true,
    },
  },
  {
    path: '/:hotelId/guest',
    name: 'findGuest',
    components: {
      default: PageFindGuestProfile,
      nav: MainNav,
      header: AppHeader,
    },
    meta: {
      role: ['ROLE_USER'],
    },
  },
  {
    path: '/:hotelId/guest/:guestProfileId',
    name: 'guest',
    components: {
      default: PageGuestProfile,
      nav: MainNav,
      header: AppHeader,
    },
    meta: {
      role: ['ROLE_USER'],
      reload: true,
    },
  },
  {
    path: '/:hotelId/guest/:guestProfileId/email',
    name: 'guestEmail',
    components: {
      default: PageEmail,
      nav: EmptyNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'guest',
      parentServiceUrl: 'guest',
      role: ['ROLE_USER'],
    },
  },
  {
    path: '/:hotelId/guest/:guestProfileId/folio',
    name: 'guestFolios',
    components: {
      default: PageFolios,
      nav: FolioNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'guest',
      role: ['ROLE_USER'],
      reload: true,
    },
  },
  {
    path: '/:hotelId/guest/:guestProfileId/folio/:folioId',
    name: 'guestFolio',
    components: {
      default: PageFolio,
      nav: FolioNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'guest',
      role: ['ROLE_USER'],
      reload: true,
    },
  },
  {
    path: '/:hotelId/guest/:guestProfileId/folio/:folioId/email',
    name: 'guestFolioEmail',
    components: {
      default: PageEmail,
      nav: EmptyNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'guestFolio',
      parentServiceUrl: 'folio',
      role: ['ROLE_USER'],
    },
  },
  {
    path: '/:hotelId/inquiry',
    name: 'findInquiry',
    components: {
      default: PageFindHotelInquiry,
      nav: MainNav,
      header: AppHeader,
    },
    props: {
      default: true,
      nav: false,
      header: false,
    },
    meta: {
      role: ['ROLE_USER'],
      reload: true,
    },
  },
  {
    path: '/:hotelId/inquiry/:inquiryId',
    name: 'inquiry',
    components: {
      default: PageHotelInquiry,
      nav: MainNav,
      header: AppHeader,
    },
    props: {
      default: true,
      nav: false,
      header: false,
    },
    meta: {
      role: ['ROLE_USER'],
    },
  },
  {
    path: '/:hotelId/inquiry/:inquiryId/email',
    name: 'inquiryEmail',
    components: {
      default: PageEmail,
      nav: EmptyNav,
      header: AppHeaderWhite,
    },
    props: {
      default: true,
      nav: false,
      header: false,
    },
    meta: {
      headerMode: 'white',
      parent: 'inquiry',
      parentServiceUrl: 'inquiry',
      role: ['ROLE_USER'],
    },
  },
  {
    path: '/:hotelId/offer',
    name: 'findOffer',
    components: {
      default: PageFindGuestOffer,
      nav: MainNav,
      header: AppHeader,
    },
    props: {
      default: true,
      nav: false,
      header: false,
    },
    meta: {
      role: ['ROLE_USER'],
      reload: true,
    },
  },
  {
    path: '/:hotelId/offer/:guestOfferId',
    name: 'offer',
    components: {
      default: PageGuestOffer,
      nav: MainNav,
      header: AppHeader,
    },
    props: {
      default: true,
      nav: false,
      header: false,
    },
    meta: {
      role: ['ROLE_USER'],
      reload: true,
    },
  },
  {
    path: '/:hotelId/offer/:guestOfferId/email',
    name: 'offerEmail',
    components: {
      default: PageEmail,
      nav: EmptyNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'offer',
      parentServiceUrl: 'offer',
      role: ['ROLE_USER'],
    },
  },
  {
    path: '/:hotelId/reservation',
    name: 'findReservation',
    components: {
      default: PageFindReservation,
      nav: MainNav,
      header: AppHeader,
    },
    props: {
      default: true,
      nav: false,
      header: false,
    },
    meta: {
      role: ['ROLE_USER'],
      reload: true,
    },
  },
  {
    path: '/:hotelId/selfcheckin/reviewCandidates',
    name: 'reviewSelfCheckInCandidates',
    components: {
      default: PageReviewSelfCheckInCandidates,
      nav: MainNav,
      header: AppHeader,
    },
    props: {
      default: true,
      nav: false,
      header: false,
    },
    meta: {
      role: ['ROLE_USER'],
      license: ['SelfCheckIn'],
      reload: true,
    },
  },
  {
    path: '/:hotelId/reservation/new',
    name: 'createReservation',
    components: {
      default: PageCreateReservation,
      nav: MainNav,
      header: AppHeader,
    },
    props: {
      default: true,
      nav: false,
      header: false,
    },
    meta: {
      role: ['ROLE_RESERVATION_REQUEST', 'ROLE_RESERVATION_NOTIFICATION'],
    },
  },
  {
    path: '/:hotelId/reservation/draft',
    name: 'draftReservation',
    components: {
      default: PageDraftReservation,
      nav: MainNav,
      header: AppHeader,
    },
    props: {
      default: true,
      nav: false,
      header: false,
    },
    meta: {
      role: ['ROLE_RESERVATION_REQUEST', 'ROLE_RESERVATION_NOTIFICATION'],
    },
  },
  {
    path: '/:hotelId/reservationGroup/:confirmationNumberOrReservationGroupId',
    name: 'reservationGroup',
    components: {
      default: PageReservationGroup,
      nav: MainNav,
      header: AppHeader,
    },
    meta: {
      role: ['ROLE_USER'],
    },
  },
  {
    path: '/:hotelId/reservationGroup/:confirmationNumberOrReservationGroupId/email',
    name: 'reservationGroupEmail',
    components: {
      default: PageEmail,
      nav: EmptyNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'reservationGroup',
      parentServiceUrl: 'reservationGroup',
      role: ['ROLE_USER'],
    },
  },
  {
    path: '/:hotelId/meldeblatt/:meldeblattId',
    name: 'meldeblatt',
    components: {
      default: PageMeldeblatt,
      nav: MainNav,
      header: AppHeader,
    },
    meta: {
      role: ['ROLE_USER'],
      reload: true,
    },
  },
  {
    path: '/:hotelId/reservation/:reservationId/paymentRequest/:paymentRequestId',
    name: 'reservationPaymentRequest',
    components: {
      default: PagePaymentRequest,
      nav: MainNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'reservation',
      parentServiceUrl: 'reservation',
      role: ['ROLE_USER'],
      reload: true,
    },
  },
  {
    path: '/:hotelId/paymentRequest/:paymentRequestId',
    name: 'paymentRequest',
    components: {
      default: PagePaymentRequest,
      nav: MainNav,
      header: AppHeaderWhite,
    },
    meta: {
      role: ['ROLE_USER'],
      reload: true,
    },
  },
  {
    path: '/:hotelId/reservation/:reservationId',
    name: 'reservation',
    components: {
      default: PageRoomReservation,
      nav: MainNav,
      header: AppHeader,
    },
    meta: {
      parent: 'reservation',
      role: ['ROLE_USER'],
      reload: true,
    },
  },
  {
    path: '/:hotelId/reservation2/:reservationId',
    name: 'reservation2',
    components: {
      default: PageRoomReservation,
      nav: SpecialNav,
      header: AppHeader,
    },
    meta: {
      parent: 'reservation',
      role: ['ROLE_USER'],
      reload: true,
    },
  },
  {
    path: '/:hotelId/reservation/:reservationId/email',
    name: 'reservationEmail',
    components: {
      default: PageEmail,
      nav: EmptyNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'reservation',
      parentServiceUrl: 'reservation',
      role: ['ROLE_USER'],
    },
  },
  {
    path: '/:hotelId/reservation/:reservationId/document',
    name: 'reservationDocument',
    components: {
      default: PageDocument,
      nav: EmptyNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'reservation',
      parentServiceUrl: 'reservation',
      role: ['ROLE_USER'],
    },
  },
  {
    path: '/:hotelId/reservation/:reservationId/folio',
    name: 'reservationFolios',
    components: {
      default: PageFolios,
      nav: FolioNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'reservation',
      role: ['ROLE_USER'],
      reload: true,
    },
  },
  {
    path: '/:hotelId/reservation/:reservationId/folio/:folioId',
    name: 'reservationFolio',
    components: {
      default: PageFolio,
      nav: FolioNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'reservation',
      role: ['ROLE_USER'],
      reload: true,
    },
  },
  {
    path: '/:hotelId/reservation/:reservationId/folio/:folioId/email',
    name: 'reservationFolioEmail',
    components: {
      default: PageEmail,
      nav: EmptyNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'reservationFolio',
      parentServiceUrl: 'folio',
      role: ['ROLE_USER'],
    },
  },
  // *****************************
  // ** ADMIN ** ADMIN ** ADMIN **
  // *****************************
  {
    path: '/:hotelId/tenant/new',
    name: 'createTenant',
    components: {
      default: PageCreateTenant,
      nav: EmptyNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'home',
      role: ['ROLE_SYSADMIN'],
    },
  },
  {
    path: '/:hotelId/hotel/base',
    name: 'hotel',
    components: {
      default: PageHotel,
      nav: MainNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'home',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_SYSADMIN'],
    },
  },
  {
    path: '/:hotelId/hotel/invoice',
    name: 'invoiceSettings',
    components: {
      default: PageInvoiceSettings,
      nav: MainNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'home',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_SYSADMIN'],
    },
  },
  {
    path: '/:hotelId/hotel/settings',
    name: 'hotelSettings',
    components: {
      default: PageHotelSettings,
      nav: MainNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'home',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_SYSADMIN'],
    },
  },
  {
    path: '/:hotelId/hotel/hotelmeisterInvoices',
    name: 'hotelHotelmeisterInvoices',
    components: {
      default: PageHotelmeisterInvoices,
      nav: MainNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'home',
      expandedSubmenu: 'settings',
      role: ['ROLE_FINANCIAL_REPORTS', 'ROLE_SYSADMIN'],
    },
  },
  {
    path: '/:hotelId/roomType',
    name: 'roomTypes',
    components: {
      default: PageRoomTypes,
      nav: RoomTypeNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'home',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_SYSADMIN'],
    },
  },
  {
    path: '/:hotelId/roomType/:roomTypeId',
    name: 'roomType',
    components: {
      default: PageRoomType,
      nav: RoomTypeNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'roomTypes',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_SYSADMIN'],
    },
  },
  {
    path: '/:hotelId/room',
    name: 'rooms',
    components: {
      default: PageRooms,
      nav: RoomNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'home',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_SYSADMIN'],
    },
  },
  {
    path: '/:hotelId/room/:roomId',
    name: 'room',
    components: {
      default: PageRoom,
      nav: RoomNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'rooms',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_SYSADMIN'],
    },
  },
  {
    path: '/:hotelId/ratePlan',
    name: 'ratePlans',
    components: {
      default: PageRatePlans,
      nav: RatePlanNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'home',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_RATE_ADMIN', 'ROLE_SYSADMIN'],
    },
  },
  {
    path: '/:hotelId/ratePlan/:ratePlanId',
    name: 'ratePlan',
    components: {
      default: PageRatePlan,
      nav: RatePlanNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'ratePlans',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_RATE_ADMIN', 'ROLE_SYSADMIN'],
    },
  },
  {
    path: '/:hotelId/seasonRateEditor',
    name: 'seasonRateEditorRatePlans',
    components: {
      default: PageSeasonRateEditorRatePlans,
      nav: SeasonRateEditorNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'home',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_RATE_ADMIN', 'ROLE_SYSADMIN'],
    },
  },
  {
    path: '/:hotelId/seasonRateEditor/:ratePlanId',
    name: 'seasonRateEditor',
    components: {
      default: PageSeasonRateEditor,
      nav: SeasonRateEditorNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'seasonRateEditorRatePlans',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_RATE_ADMIN', 'ROLE_SYSADMIN'],
    },
  },
  {
    path: '/:hotelId/dailyRateEditor/:ratePlanId',
    name: 'dailyRateEditor',
    components: {
      default: PageDayRateEditor,
      nav: SeasonRateEditorNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'seasonRateEditorRatePlans',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_RATE_ADMIN', 'ROLE_SYSADMIN'],
    },
  },
  {
    path: '/:hotelId/dailyRateOverview/:ratePlanType',
    name: 'dailyRateOverview',
    components: {
      default: PageDayRateOverview,
      nav: SeasonRateEditorNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'seasonRateEditorRatePlans',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_RATE_ADMIN', 'ROLE_SYSADMIN'],
    },
  },
  {
    path: '/:hotelId/inHouseService',
    name: 'inHouseServices',
    components: {
      default: PageInHouseServices,
      nav: InHouseServiceNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'home',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_SYSADMIN'],
    },
  },
  {
    path: '/:hotelId/inHouseService/:inHouseServiceId',
    name: 'inHouseService',
    components: {
      default: PageInHouseService,
      nav: InHouseServiceNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'inHouseServices',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_SYSADMIN'],
    },
  },
  {
    path: '/:hotelId/template',
    name: 'templates',
    components: {
      default: PageTemplates,
      nav: TemplateNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'home',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_SYSADMIN'],
    },
  },
  {
    path: '/:hotelId/template/:templateId',
    name: 'template',
    components: {
      default: PageTemplate,
      nav: TemplateNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'templates',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_SYSADMIN'],
    },
  },
  {
    path: '/:hotelId/mealPlan',
    name: 'mealPlans',
    components: {
      default: PageMealPlans,
      nav: MealPlanNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'home',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_SYSADMIN'],
    },
  },
  {
    path: '/:hotelId/mealPlan/:mealPlanId',
    name: 'mealPlan',
    components: {
      default: PageMealPlan,
      nav: MealPlanNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'mealPlans',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_SYSADMIN'],
    },
  },
  {
    path: '/:hotelId/policy',
    name: 'policies',
    components: {
      default: PagePolicies,
      nav: PolicyNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'home',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_SYSADMIN'],
    },
  },
  {
    path: '/:hotelId/policy/:policyId',
    name: 'policy',
    components: {
      default: PagePolicy,
      nav: PolicyNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'policies',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_SYSADMIN'],
    },
  },
  {
    path: '/:hotelId/user',
    name: 'users',
    components: {
      default: PageUsers,
      nav: UserNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'home',
      expandedSubmenu: 'settings',
      role: ['ROLE_USER', 'ROLE_UNIT_OWNER', 'ROLE_ADMIN', 'ROLE_SYSADMIN'],
    },
  },
  {
    path: '/:hotelId/user/:userId',
    name: 'user',
    components: {
      default: PageUser,
      nav: UserNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'users',
      expandedSubmenu: 'settings',
      role: ['ROLE_USER', 'ROLE_UNIT_OWNER', 'ROLE_ADMIN', 'ROLE_SYSADMIN'],
    },
  },
  {
    path: '/:hotelId/tax',
    name: 'taxes',
    components: {
      default: PageTaxes,
      nav: TaxNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'home',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_SYSADMIN'],
    },
  },
  {
    path: '/:hotelId/tax/:taxId',
    name: 'tax',
    components: {
      default: PageTax,
      nav: TaxNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'taxes',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_SYSADMIN'],
    },
  },
  {
    path: '/:hotelId/taxSet',
    name: 'taxSets',
    components: {
      default: PageTaxSets,
      nav: TaxSetNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'home',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_SYSADMIN'],
    },
  },
  {
    path: '/:hotelId/taxSet/:taxSetId',
    name: 'taxSet',
    components: {
      default: PageTaxSet,
      nav: TaxSetNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'taxSets',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_SYSADMIN'],
    },
  },
  {
    path: '/:hotelId/discountCode',
    name: 'discountCodes',
    components: {
      default: PageDiscountCodes,
      nav: DiscountCodeNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'home',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_SYSADMIN'],
    },
  },
  {
    path: '/:hotelId/discountCode/:discountCodeId',
    name: 'discountCode',
    components: {
      default: PageDiscountCode,
      nav: DiscountCodeNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'discountCodes',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_SYSADMIN'],
    },
  },
  {
    path: '/:hotelId/inventory',
    name: 'inventory',
    components: {
      default: PageInventory,
      nav: MainNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'home',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_SYSADMIN'],
    },
  },
  {
    path: '/:hotelId/inventoryLog',
    name: 'inventoryLog',
    components: {
      default: PageInventoryLogs,
      nav: MainNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'home',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_SYSADMIN'],
    },
  },
  {
    path: '/:hotelId/csvImport',
    name: 'csvImport',
    components: {
      default: PageImport,
      nav: MainNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'home',
      expandedSubmenu: 'settings',
      role: ['ROLE_SYSADMIN'],
    },
  },
  {
    path: '/:hotelId/guestCategory',
    name: 'guestCategories',
    components: {
      default: PageGuestCategories,
      nav: MainNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'home',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_SYSADMIN'],
    },
  },
  {
    path: '/:hotelId/messagingSequence/:messagingSequenceType',
    name: 'messagingSequence',
    components: {
      default: PageMessagingSequences,
      nav: MainNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'home',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_SYSADMIN'],
    },
  },
  {
    path: '/:hotelId/ageCategory',
    name: 'ageCategories',
    components: {
      default: PageAgeCategories,
      nav: AgeCategoryNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'home',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_SYSADMIN'],
    },
  },
  {
    path: '/:hotelId/ageCategory/:ageCategoryId',
    name: 'ageCategory',
    components: {
      default: PageAgeCategory,
      nav: AgeCategoryNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'ageCategories',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_SYSADMIN'],
    },
  },
  {
    path: '/:hotelId/seasonCalendar',
    name: 'seasonCalendars',
    components: {
      default: PageSeasonCalendars,
      nav: SeasonCalendarNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'home',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_RATE_ADMIN', 'ROLE_SYSADMIN'],
    },
  },
  {
    path: '/:hotelId/seasonCalendar/:ratePlanType',
    name: 'seasonCalendar',
    components: {
      default: PageSeasonCalendar,
      nav: SeasonCalendarNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'seasonCalendars',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_RATE_ADMIN', 'ROLE_SYSADMIN'],
    },
  },
  {
    path: '/:hotelId/season',
    name: 'seasons',
    components: {
      default: PageSeasons,
      nav: SeasonNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'home',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_RATE_ADMIN', 'ROLE_SYSADMIN'],
    },
  },
  {
    path: '/:hotelId/season/:seasonId',
    name: 'season',
    components: {
      default: PageSeason,
      nav: SeasonNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'seasons',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_RATE_ADMIN', 'ROLE_SYSADMIN'],
    },
  },
  {
    path: '/:hotelId/report',
    name: 'listReports',
    components: {
      default: PageListReports,
      nav: MainNav,
      header: AppHeader,
    },
    props: {
      default: true,
      nav: false,
      header: false,
    },
    meta: {
      role: ['ROLE_USER', 'ROLE_UNIT_OWNER_REPORTS'],
    },
  },
  {
    path: '/:hotelId/interface',
    name: 'interfaces',
    components: {
      default: PageInterfaces,
      nav: InterfaceNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'home',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_SYSADMIN', 'ROLE_INTERFACES'],
    },
  },
  {
    path: '/:hotelId/interface/channelManager',
    name: 'interfaces.hotelSpider',
    components: {
      default: PageHotelSpider,
      nav: InterfaceNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'interfaces',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_SYSADMIN', 'ROLE_INTERFACES'],
    },
  },
  {
    path: '/:hotelId/interface/connectS',
    name: 'interfaces.connectS',
    components: {
      default: PageChannelManagerSu,
      nav: InterfaceNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'interfaces',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_SYSADMIN', 'ROLE_INTERFACES'],
    },
  },
  {
    path: '/:hotelId/interface/connectSbookings',
    name: 'interfaces.connectSbookings',
    components: {
      default: PageChannelManagerSuBookings,
      nav: MainNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'home',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_SYSADMIN', 'ROLE_INTERFACES'],
    },
  },
  {
    path: '/:hotelId/interface/charPmsLink/:configId',
    name: 'interfaces.charPmsLink',
    components: {
      default: PageCharPmsLink,
      nav: InterfaceNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'interfaces',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_SYSADMIN', 'ROLE_INTERFACES'],
    },
  },
  {
    path: '/:hotelId/interface/connectCX/:configId',
    name: 'interfaces.connectCX',
    components: {
      default: PageChannelManagerCx,
      nav: InterfaceNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'interfaces',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_SYSADMIN', 'ROLE_INTERFACES'],
    },
  },
  {
    path: '/:hotelId/interface/smartpricing',
    name: 'interfaces.smartpricing',
    components: {
      default: PageSmartpricing,
      nav: InterfaceNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'interfaces',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_SYSADMIN', 'ROLE_INTERFACES'],
    },
  },
  {
    path: '/:hotelId/interface/locking',
    name: 'interfaces.locking',
    components: {
      default: PageLockingSettings,
      nav: InterfaceNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'interfaces',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_SYSADMIN', 'ROLE_INTERFACES'],
    },
  },
  {
    path: '/:hotelId/interface/locking/:interfaceId/devices',
    name: 'interfaces.locking.devices',
    components: {
      default: PageLockingSeamIframe,
      nav: InterfaceNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'interfaces.locking',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_SYSADMIN', 'ROLE_INTERFACES'],
    },
  },
  {
    path: '/:hotelId/interface/connectSmapping',
    name: 'interfaces.connectSmapping',
    components: {
      default: PageChannelManagerSuMapping,
      nav: InterfaceNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'interfaces',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_SYSADMIN', 'ROLE_INTERFACES'],
    },
  },
  {
    path: '/:hotelId/interface/connectSmappingV2',
    name: 'interfaces.connectSmappingV2',
    components: {
      default: PageChannelManagerSuMappingV2,
      nav: InterfaceNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'interfaces',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_SYSADMIN', 'ROLE_INTERFACES'],
    },
  },
  {
    path: '/:hotelId/interface/connectCXmapping/:configId',
    name: 'interfaces.connectCXmapping',
    components: {
      default: PageChannelManagerCxMapping,
      nav: InterfaceNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'interfaces',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_SYSADMIN', 'ROLE_INTERFACES'],
    },
  },
  {
    path: '/:hotelId/interface/connectCXproperty/:configId',
    name: 'interfaces.connectCXproperty',
    components: {
      default: PageChannelManagerCxIframe,
      nav: InterfaceNav,
      header: AppHeaderWhite,
    },
    meta: {
      cxIframe: 'propertyIframe',
      headerMode: 'white',
      parent: 'home',
      expandedSubmenu: 'settings',
      role: ['ROLE_HOTELMEISTER_SUPER_ADMIN'],
    },
  },
  {
    path: '/:hotelId/interface/connectCXbookings/:configId',
    name: 'interfaces.connectCXbookings',
    components: {
      default: PageChannelManagerCxIframe,
      nav: MainNav,
      header: AppHeaderWhite,
    },
    meta: {
      cxIframe: 'bookingsIframe',
      headerMode: 'white',
      parent: 'home',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_SYSADMIN', 'ROLE_INTERFACES'],
    },
  },
  {
    path: '/:hotelId/interface/connectCXdashboard/:configId',
    name: 'interfaces.connectCXdashboard',
    components: {
      default: PageChannelManagerCxIframe,
      nav: InterfaceNav,
      header: AppHeaderWhite,
    },
    meta: {
      cxIframe: 'dashboardIframe',
      headerMode: 'white',
      parent: 'home',
      expandedSubmenu: 'settings',
      role: ['ROLE_HOTELMEISTER_SUPER_ADMIN'],
    },
  },
  {
    path: '/:hotelId/interface/connectCXinventory/:configId',
    name: 'interfaces.connectCXinventory',
    components: {
      default: PageChannelManagerCxIframe,
      nav: InterfaceNav,
      header: AppHeaderWhite,
    },
    meta: {
      cxIframe: 'inventoryIframe',
      headerMode: 'white',
      parent: 'home',
      expandedSubmenu: 'settings',
      role: ['ROLE_HOTELMEISTER_SUPER_ADMIN'],
    },
  },
  {
    path: '/:hotelId/interface/connectCXrooms/:configId',
    name: 'interfaces.connectCXrooms',
    components: {
      default: PageChannelManagerCxIframe,
      nav: InterfaceNav,
      header: AppHeaderWhite,
    },
    meta: {
      cxIframe: 'roomsIframe',
      headerMode: 'white',
      parent: 'home',
      expandedSubmenu: 'settings',
      role: ['ROLE_HOTELMEISTER_SUPER_ADMIN'],
    },
  },
  {
    path: '/:hotelId/interface/connectSlogs',
    name: 'interfaces.connectSlogs',
    components: {
      default: PageChannelManagerSuLogs,
      nav: InterfaceNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'interfaces',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_SYSADMIN', 'ROLE_INTERFACES'],
    },
  },
  {
    path: '/:hotelId/interface/genericPos',
    name: 'interfaces.genericPos',
    components: {
      default: PageGenericPos,
      nav: InterfaceNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'interfaces',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_SYSADMIN', 'ROLE_INTERFACES'],
    },
  },
  {
    path: '/:hotelId/interface/iCal',
    name: 'interfaces.iCal',
    components: {
      default: PageICal,
      nav: InterfaceNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'interfaces',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_SYSADMIN', 'ROLE_INTERFACES'],
    },
  },
  {
    path: '/:hotelId/interface/salesbox/:interfaceId',
    name: 'interfaces.interalpSalesbox',
    components: {
      default: PageInteralpSalesbox,
      nav: InterfaceNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'interfaces',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_SYSADMIN', 'ROLE_INTERFACES'],
    },
  },
  {
    path: '/:hotelId/interface/kiosk',
    name: 'interfaces.kiosk',
    components: {
      default: PageKiosk,
      nav: InterfaceNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'interfaces',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_SYSADMIN', 'ROLE_INTERFACES'],
    },
  },
  {
    path: '/:hotelId/interface/logs',
    name: 'interfaces.logs',
    components: {
      default: PageLogs,
      nav: InterfaceNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'interfaces',
      expandedSubmenu: 'settings',
      role: ['ROLE_HOTELMEISTER_SUPER_ADMIN'],
    },
  },
  {
    path: '/:hotelId/interface/aTrustRegMobile',
    name: 'interfaces.aTrustRegMobile',
    components: {
      default: PageATrustRegMobile,
      nav: InterfaceNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'interfaces',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_SYSADMIN', 'ROLE_INTERFACES'],
    },
  },
  {
    path: '/:hotelId/interface/exchangeRate',
    name: 'interfaces.exchangeRates',
    components: {
      default: PageExchangeRates,
      nav: InterfaceNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'interfaces',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_SYSADMIN', 'ROLE_INTERFACES'],
    },
  },
  {
    path: '/:hotelId/interface/fiskaltrustDE',
    name: 'interfaces.fiskaltrustDE',
    components: {
      default: PageFiskaltrustDE,
      nav: InterfaceNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'interfaces',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_SYSADMIN', 'ROLE_INTERFACES'],
    },
  },
  {
    path: '/:hotelId/interface/mollie',
    name: 'interfaces.mollie',
    components: {
      default: PageMollie,
      nav: InterfaceNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'interfaces',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_SYSADMIN', 'ROLE_INTERFACES'],
    },
  },
  {
    path: '/:hotelId/interface/onlineBooking',
    name: 'interfaces.onlineBooking',
    components: {
      default: PageOnlineBooking,
      nav: InterfaceNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'interfaces',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_SYSADMIN', 'ROLE_INTERFACES', 'ROLE_RATE_ADMIN'],
    },
  },
  {
    path: '/:hotelId/interface/paymentRequest',
    name: 'interfaces.paymentRequest',
    components: {
      default: PagePaymentRequestSettings,
      nav: InterfaceNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'interfaces',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_SYSADMIN'],
    },
  },
  {
    path: '/:hotelId/interface/stripe',
    name: 'interfaces.stripe',
    components: {
      default: PageStripe,
      nav: InterfaceNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'interfaces',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_SYSADMIN', 'ROLE_INTERFACES'],
    },
  },
  {
    path: '/:hotelId/interface/fanz',
    name: 'interfaces.fanz',
    components: {
      default: PageFanz,
      nav: InterfaceNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'interfaces',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_SYSADMIN', 'ROLE_INTERFACES'],
    },
  },
  {
    path: '/:hotelId/interface/meldeclient/:interfaceId',
    name: 'interfaces.meldeclient',
    components: {
      default: PageMeldeclient,
      nav: InterfaceNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'interfaces',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_SYSADMIN', 'ROLE_INTERFACES'],
    },
  },
  {
    path: '/:hotelId/registrierkasse/at',
    name: 'registrierkasse.at',
    components: {
      default: PageRegistrierkasseAT,
      nav: MainNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'home',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_USER', 'ROLE_SYSADMIN'],
    },
  },
  {
    path: '/:hotelId/registrierkasse/de',
    name: 'registrierkasse.de',
    components: {
      default: PageRegistrierkasseDE,
      nav: MainNav,
      header: AppHeaderWhite,
    },
    meta: {
      headerMode: 'white',
      parent: 'home',
      expandedSubmenu: 'settings',
      role: ['ROLE_ADMIN', 'ROLE_USER', 'ROLE_SYSADMIN'],
    },
  },
  {
    path: '/:hotelId/enableKassenSichV',
    name: 'enableKassenSichV',
    components: {
      default: PageKassenSichV,
      nav: MainNav,
      header: AppHeader,
    },
    meta: {
      parent: 'home',
      role: ['ROLE_ADMIN', 'ROLE_USER', 'ROLE_SYSADMIN'],
    },
  },
];



// WEBPACK FOOTER //
// ./src/lib/routes.js